import { Features } from "components/Actions/dialogs/Devices/AutoSync/types/interfaces";
import {
    CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES,
    CONFIGURATION_FEATURE_SETTINGS_MODES,
    CONFIGURATION_TYPES
} from "shared/types/enums";

import { FIRMWARE_FEATURES } from "./types/enums";
import { ConfigurationChange, SingleDeviceData } from "./types/interfaces";

const data = {
    [CONFIGURATION_TYPES.MainConfiguration]: {
        featureSettings:
            CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.MainConfigurationSync,
        firmwareFeatures: FIRMWARE_FEATURES.MainConfigurationAutoSyncSupport
    },
    [CONFIGURATION_TYPES.OneWireAuthorizationList]: {
        featureSettings:
            CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.OneWireAuthListSync,
        firmwareFeatures: FIRMWARE_FEATURES.OneWireListAutoSyncSupport
    },
    [CONFIGURATION_TYPES.BluetoothAuthorizationList]: {
        featureSettings:
            CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.BluetoothAuthListSync,
        firmwareFeatures: FIRMWARE_FEATURES.BluetoothListAutoSyncSupport
    },
    [CONFIGURATION_TYPES.ManualGeofenceList]: {
        featureSettings:
            CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.ManualGeofenceListSync,
        firmwareFeatures: FIRMWARE_FEATURES.GeofenceListAutoSyncSupport
    }
};

export const getUserSentConfiguration = (
    configType: CONFIGURATION_TYPES,
    deviceData: SingleDeviceData
) => {
    const {
        "1_wire_authorization_list": one_wire_authorization_list,
        bluetooth_authorization_list,
        current_configuration,
        manual_geofence_list
    } = deviceData;

    const files = {
        [CONFIGURATION_TYPES.MainConfiguration]: current_configuration,
        [CONFIGURATION_TYPES.OneWireAuthorizationList]:
            one_wire_authorization_list,
        [CONFIGURATION_TYPES.BluetoothAuthorizationList]:
            bluetooth_authorization_list,
        [CONFIGURATION_TYPES.ManualGeofenceList]: manual_geofence_list
    };

    return files[configType];
};

export const getFeatureSettingsName = (configType: CONFIGURATION_TYPES) =>
    data[configType].featureSettings;

export const getFeatureSettings = (
    configType: CONFIGURATION_TYPES,
    featureSettings: Features | null
) => {
    const featureSettingsName = getFeatureSettingsName(configType);

    return (
        featureSettings?.[featureSettingsName] ??
        CONFIGURATION_FEATURE_SETTINGS_MODES.Disabled
    );
};

export const getFeatureFlagStatus = (
    configType: CONFIGURATION_TYPES,
    firmwareFeatures: FIRMWARE_FEATURES[] | null
) => {
    const firmwareFeaturesName = data[configType].firmwareFeatures;

    return firmwareFeatures?.includes(firmwareFeaturesName) ?? null;
};

export const getConfigurationChange = (
    configType: CONFIGURATION_TYPES,
    configChanges: ConfigurationChange[]
) => configChanges.find(change => change.type === configType) ?? null;
